import React, { useEffect, useState } from "react";
import { Card, Col, Select, Statistic, Row, Table, Tag, message } from "antd";

import ReportFilterBar from "../components/ReportFilterBar";
import ReportExportButton from "../components/ReportExportButton";
import { fetchDealPerformanceReportApi } from "../../../apiservice/crm";

const STAGE_COLOR = {
  prospecting: "blue",
  negotiation: "orange",
  won: "green",
  lost: "red",
};

const DealReports = () => {
  const [filters, setFilters] = useState({});
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({ total_count: 0, total_value: 0, won_count: 0, won_value: 0, win_rate: 0 });
  const [loading, setLoading] = useState(false);

  const load = async (nextFilters = filters) => {
    setLoading(true);
    try {
      const res = await fetchDealPerformanceReportApi(nextFilters);
      setData(res.data?.data || []);
      setSummary(res.data?.summary || {});
    } catch (err) {
      message.error(err?.response?.data?.message || "Failed to load deal performance report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const columns = [
    { title: "Deal", dataIndex: "title" },
    { title: "Contact", dataIndex: "contact_name" },
    { title: "Value", dataIndex: "value", align: "right" },
    {
      title: "Stage",
      dataIndex: "stage",
      render: (v) => <Tag color={STAGE_COLOR[v] || "default"}>{v}</Tag>,
    },
    { title: "Assigned To", dataIndex: "assigned_user" },
    { title: "Created", dataIndex: "created_at" },
  ];

  return (
    <>
      <ReportFilterBar
        filters={filters}
        onChange={(partial) => setFilters((f) => ({ ...f, ...partial }))}
        onApply={() => load()}
        onReset={() => {
          setFilters({});
          load({});
        }}
        loading={loading}
        extra={
          <Col xs={24} sm={12} md={8} lg={4}>
            <label>Stage</label>
            <Select
              allowClear
              placeholder="All"
              style={{ width: "100%" }}
              size="large"
              value={filters.stage || undefined}
              onChange={(v) => {
                const next = { ...filters, stage: v || null };
                setFilters(next);
                load(next);
              }}
              options={[
                { label: "Prospecting", value: "prospecting" },
                { label: "Negotiation", value: "negotiation" },
                { label: "Won", value: "won" },
                { label: "Lost", value: "lost" },
              ]}
            />
          </Col>
        }
      />

      <Card title="Deal & Sales Performance" extra={<ReportExportButton reportType="deals-performance" filters={filters} />}>
        <Row gutter={16} className="mb-4">
          <Col><Statistic title="Total Deals" value={summary.total_count || 0} /></Col>
          <Col><Statistic title="Total Value" value={summary.total_value || 0} precision={2} /></Col>
          <Col><Statistic title="Won" value={summary.won_count || 0} valueStyle={{ color: "#3f8600" }} /></Col>
          <Col><Statistic title="Won Value" value={summary.won_value || 0} precision={2} valueStyle={{ color: "#3f8600" }} /></Col>
          <Col><Statistic title="Win Rate" value={summary.win_rate || 0} suffix="%" /></Col>
        </Row>

        <Table
          rowKey="deal_id"
          columns={columns}
          dataSource={data}
          loading={loading}
          bordered
          scroll={{ x: "max-content" }}
        />
      </Card>
    </>
  );
};

export default DealReports;
